module.exports = __webpack_public_path__ + "assets/img/lvjuan.bbdbdf7b.png";